import { cva } from "@-/com.npmjs.cva";
import { cn } from "@-/com.npmjs.cn";
import { Platform } from "@-/com.npmjs.react-native";

export const toggleVariants = cva({
  base: cn(
    "group flex flex-row items-center justify-center gap-2 rounded-xs active:bg-accent",
    Platform.select({
      web: "hover:bg-accent hover:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive inline-flex cursor-default whitespace-nowrap outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:pointer-events-none [&_svg]:pointer-events-none",
    }),
  ),
  defaultVariants: {
    size: "default",
    variant: "default",
  },
  variants: {
    size: {
      default: "h-10 min-w-10 px-2.5 sm:h-9 sm:min-w-9 sm:px-2",
      lg: "h-11 min-w-11 px-3 sm:h-10 sm:min-w-10 sm:px-2.5",
      sm: "h-9 min-w-9 px-2 sm:h-8 sm:min-w-8 sm:px-1.5",
    },
    variant: {
      default: "bg-transparent",
      outline: cn(
        "border border-input bg-transparent shadow-sm shadow-black/5 active:bg-accent",
        Platform.select({
          web: "hover:bg-accent hover:text-accent-foreground",
        }),
      ),
    },
  },
});
